<template>
  <div class="content-c">
    <title-bar :title="$lang.recordOrder_title"></title-bar>
    <!-- 列表展示 -->
    <van-list
      v-model="loading"
      :finished="finished"
      loading-text=" "
      @load="loadMore"
      class="order-list"
    >
      <p v-if="recordErrorMessage" class="record-error">
        {{ recordErrorMessage }}
      </p>
      <div
        class="order-list--item"
        v-for="(item, index) in orderList"
        :key="item.orderNo || index"
        @click="goToD(item)"
      >
        <div class="d-flex">
          <!-- <img src="../../../assets/img/home/pix-H.png" height="30" /> -->
          <div class="m-l-10">
            <p v-if="item.orderType === 'pay'">{{ $lang.Recarregar }}</p>
            <p v-else>
              <span>{{ $lang.recordOrder_txt }} {{ $lang.account }}</span
              ><span v-if="withdrawAccountText(item)">({{ withdrawAccountText(item) }})</span>
            </p>

            <p class="font-color m-t-10">{{ item.createDate || '-' }}</p>
          </div>
        </div>
        <div>
          <div style="text-align: right">
            <p v-if="item.orderType === 'wd'" class="error-color">
              - {{ $formatNumberWithCommas(item.orderAmount) }}
            </p>
            <p v-else class="primary-color">
              + {{ $formatNumberWithCommas(item.orderAmount) }}
            </p>
          </div>
          <div class="m-t-10">
            <p v-if="isSuccessful(item)" style="color: #09b760">
              <van-icon name="success" size="12" style="margin-right: 2px" />
              {{ statusText(item) }}
            </p>
            <p
              class="error-color"
              v-else-if="isFailed(item)"
            >
              {{ statusText(item) }}
            </p>
            <p v-else style="color: #e8c03c">
              {{ statusText(item) }}
            </p>
          </div>
        </div>
      </div>
      <!-- 没有数据时显示 -->
      <van-empty
        v-if="!orderList.length && !loading"
        :image="require('../../../assets/img/common/img_no_data.png')"
        :description="$lang.noempt"
      />
    </van-list>
  </div>
</template>
<script>
import { GetRWHistory } from '@/api/modules/recharge'
import {
  contentOf,
  displayOrderStatusName,
  failMessage,
  firstArray,
  handleNeedLogin,
  isFailedOrderStatus,
  isOk,
  isSuccessfulOrderStatus,
  normalizeOrderRecord
} from './safeFlow'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

export default {
  name: 'recordOrder',
  components: {},

  data() {
    return {
      orderList: [], // 订单列表数据
      loading: false, // 是否正在加载更多数据
      finished: false, // 是否已经加载完所有数据
      // isRefreshing: false, // 是否正在下拉刷新
      page: 0, // 当前页码
      pageSize: 20,
      recordErrorMessage: ''
    }
  },
  mounted() {},
  methods: {
    safeToast(payload) {
      if (typeof this.$toast === 'function') {
        this.$toast(payload)
      }
    },
    // 格式化银行卡号
    formatCardNumber(cardNumber) {
      if (!cardNumber) return '' // 如果为空，直接返回空字符串
      const value = String(cardNumber)
      const length = value.length
      if (length <= 4) return value // 如果长度小于等于4，直接返回原号码
      const stars = '***' // 前面用6个*代替
      return stars + value.slice(-4) // 返回格式化后的字符串
    },
    withdrawAccountText(item) {
      const parts = [item.bankName, this.formatCardNumber(item.bankCard)].filter(Boolean)
      return parts.join(' ')
    },
    goToD(v) {
      this.$jumpTo('/orderDetail', this.normalizeOrderItem(v))
    },
    normalizeOrderItem(item = {}) {
      return normalizeOrderRecord(item, this.$lang)
    },
    isSuccessful(item) {
      return isSuccessfulOrderStatus(item.orderStatus)
    },
    isFailed(item) {
      return isFailedOrderStatus(item.orderStatus)
    },
    statusText(item) {
      return displayOrderStatusName(item, this.$lang)
    },
    orderRecordIdentityKey(item = {}) {
      const stableId = item.orderNo || item.orderId || item.id
      if (stableId) return `id:${stableId}`

      const type = item.orderType || item.type
      const amount = item.orderAmount !== undefined ? item.orderAmount : item.amount
      if (!item.createDate || !type || amount === undefined || amount === null || amount === '') {
        return ''
      }

      return `detail:${item.createDate}|${type}|${amount}`
    },
    mergeOrderList(list = []) {
      if (!Array.isArray(list) || !list.length) return

      const knownKeys = new Set()
      this.orderList.forEach((item) => {
        const key = this.orderRecordIdentityKey(item)
        if (key) knownKeys.add(key)
      })

      const mergedList = this.orderList.slice()
      list.forEach((item) => {
        const key = this.orderRecordIdentityKey(item)
        if (!key) {
          mergedList.push(item)
          return
        }
        if (knownKeys.has(key)) return
        knownKeys.add(key)
        mergedList.push(item)
      })

      this.orderList = mergedList
    },
    // 获取订单列表数据
    async fetchOrderList() {
      if (!safeGetStorageItem(getLocalStorage(), 'token')) {
        this.loading = false
        this.finished = true
        this.$jumpTo('/home', {}, { replace: true })
        return
      }
      this.loading = true
      try {
        const data = await GetRWHistory({ pageIndex: this.page, pageSize: this.pageSize })
        if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) {
          this.finished = true
          return
        }
        if (!isOk(data)) {
          this.finished = true
          this.recordErrorMessage = failMessage(data)
          if (typeof this.$toast === 'function') this.$toast({ message: this.recordErrorMessage, icon: 'cross' })
          return
        }
        const content = contentOf(data)
        const rawList = firstArray(content, ['orderRecordList', 'dataList', 'list', 'records', 'capitalDetailsList'])
        const list = Array.isArray(rawList) ? rawList.map((item) => this.normalizeOrderItem(item)) : []
        // 如果没有新数据，表示加载完成
        if (list.length < this.pageSize) {
          this.finished = true
        }
        // 将新数据添加到列表中
        this.mergeOrderList(list)
        // 加载下一页
        this.page++
        this.recordErrorMessage = ''
      } catch (e) {
        this.finished = true
        this.recordErrorMessage = failMessage(e, '充值/提现记录读取失败，请稍后重试。')
        if (typeof this.$toast === 'function') this.$toast({ message: this.recordErrorMessage, icon: 'cross' })
      } finally {
        // 加载状态结束
        this.loading = false
      }
    },
    // 加载更多数据
    loadMore() {
      this.fetchOrderList()
    }
    // // 下拉刷新
    // handleRefresh() {
    //   this.isRefreshing = true
    //   this.page = 0
    //   this.finished = false
    //   this.orderList = []
    //   this.loadMore()
    // }
  }
}
</script>
<style lang="less" scoped>
/* 设置订单容器和列表的高度 */
.content-c {
  //   height: 200px; /* 固定高度 */
  //   overflow-y: auto; /* 垂直方向可滚动 */
}

.order-list {
  margin-top: 10px;
  height: 90vh; /* 固定高度 */
  overflow-y: auto; /* 垂直方向可滚动 */
  padding: 0 10px;
}
.record-error {
  color: #ffda47;
  font-size: var(--vk-fs-xs);
  line-height: 18px;
  margin: 0 0 10px;
  text-align: center;
}
.order-list--item {
  font-size: var(--vk-fs-xs);
  background: @cont-bg;
  margin-bottom: 10px;
  border-radius: 13px;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .van-loading {
  background: transparent;
  padding-top: 0%;
}
.active {
  color: @primary-color2;
}
</style>
